import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Componente de spinner de carga reutilizable
 */
const LoadingSpinner = ({ 
  size = 'md', 
  message = 'Cargando...', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };

  const containerClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };

  return (
    <div className={`flex flex-col items-center justify-center space-y-3 ${containerClasses[size]} ${className}`}>
      <Loader2 className={`${sizeClasses[size]} animate-spin text-blue-600`} />
      {message && (
        <p className="text-gray-600 font-medium">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;